import Keycloak from "keycloak-js";

const keycloak = new Keycloak({
  // url: "http://localhost:8443",
  url: "https://login.vertus.biz",
  realm: "venus",
  clientId: "venus-service",
});

export default keycloak;